import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8C7A25B6-878E-4BDB-A5B7-2927257E1B7D
 * name arrow-right-bold
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-right-bold.svg
 * tags
 * - Arrow 
 * - Automotive 
 */
export const ArrowRightBoldIcon = createSvgIcon(<><path d="M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z" /></>, 'ArrowRightBoldIcon');
export default ArrowRightBoldIcon